import React, { FunctionComponent, useState } from 'react';

import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

import { hasRentalAgreement } from 'scenes/landlord/selectors';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { RentalAgreementInfoModal } from './RentalAgreementInfoModal';

export const QUESTION = 'Do you have a rental agreement with your tenant?';
export const TOOLTIP_LINK = 'What is a rental agreement?';
export const TOOLTIP_INFO = '';
export const STATE_KEY = 'hasRentalAgreement';

const RentalAgreementStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [showModal, setShowModal] = useState(false);
  const helpLink = {
    id: 'what-is-a-rental-agreement-link',
    text: 'What is a rental agreement?',
    ariaLabel: 'What is a rental agreement? Opens dialog',
    onClick: () => setShowModal(true),
  };
  return (
    <>
      <SingleYesNoStep
        question={QUESTION}
        stateKey={STATE_KEY}
        defaultStateValue={hasRentalAgreement(funnelState)}
        onNext={onNext}
        helpLink={helpLink}
      />
      <RentalAgreementInfoModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default RentalAgreementStep;
